<template>
    <main class="p-promo">
        <div class="identity-menu">
            <router-link :to="$t('nav.home.slug')" :title="$t('nav.home.title')">
                <svg class="identity-logo" xmlns="http://www.w3.org/2000/svg" width="160" height="64" viewBox="0 0 160 64">
                    <g fill="#101010">
                        <path
                            d="M25.716 2.036H30.196V6.516H25.716zM17.455 8.495c1.454.872 2.618 2.152 3.49 3.84.815 1.687 1.28 3.665 1.28 5.876 0 2.269-.407 4.247-1.28 5.934-.814 1.688-1.978 2.968-3.49 3.84-1.455.873-3.142 1.339-5.062 1.339-1.978 0-3.666-.466-5.004-1.455-1.396-.989-2.327-2.269-2.909-3.84v5.004H0V0h4.48v12.45c.524-1.57 1.513-2.85 2.91-3.84 1.395-.988 3.083-1.454 5.003-1.454s3.549.408 5.062 1.339zM7.68 11.927c-.99.582-1.804 1.455-2.327 2.502-.582 1.106-.873 2.327-.873 3.724 0 1.454.29 2.676.873 3.782.582 1.047 1.338 1.92 2.327 2.501.99.582 2.095.873 3.375.873 1.978 0 3.607-.64 4.77-1.92 1.222-1.28 1.804-3.025 1.804-5.236s-.582-3.957-1.804-5.237c-1.221-1.28-2.792-1.861-4.77-1.861-1.28 0-2.386.29-3.375.872zM30.196 10.24L30.196 29.033 25.716 29.033 25.716 7.447zM48.29 9.076c1.514 1.28 2.445 3.026 2.794 5.179h-4.248c-.174-1.164-.698-2.153-1.512-2.851-.815-.699-1.92-1.106-3.259-1.106-1.105 0-1.978.291-2.618.815-.64.523-.93 1.28-.93 2.152 0 .699.232 1.222.64 1.63.465.407.988.756 1.687.989.64.232 1.629.523 2.85.756 1.63.35 2.91.756 3.957 1.164.989.407 1.862.989 2.618 1.861.698.873 1.106 2.037 1.106 3.491 0 1.804-.699 3.259-2.037 4.422-1.396 1.106-3.2 1.687-5.527 1.687-2.676 0-4.887-.64-6.516-1.861-1.688-1.28-2.677-3.026-3.026-5.237h4.364c.116 1.164.64 2.153 1.57 2.851.932.757 2.095 1.106 3.608 1.106 1.047 0 1.92-.291 2.56-.873.64-.582.93-1.28.93-2.153 0-.756-.232-1.338-.697-1.803-.466-.466-1.048-.815-1.746-1.048-.698-.232-1.687-.523-2.909-.756-1.57-.35-2.85-.756-3.84-1.106-.989-.349-1.804-.989-2.502-1.803-.698-.815-1.047-1.92-1.047-3.375 0-1.803.698-3.316 2.036-4.48 1.397-1.163 3.259-1.687 5.702-1.687 2.444.116 4.48.756 5.993 2.036zM68.713 9.076c1.512 1.28 2.443 3.026 2.792 5.179h-4.247c-.174-1.164-.698-2.153-1.513-2.851-.814-.699-1.92-1.106-3.258-1.106-1.105 0-1.978.291-2.618.815-.64.523-.93 1.28-.93 2.152 0 .699.232 1.222.64 1.63.465.407.988.756 1.686.989.64.232 1.63.523 2.851.756 1.63.35 2.91.756 3.957 1.164.989.407 1.862.989 2.618 1.861.698.873 1.105 2.037 1.105 3.491 0 1.804-.698 3.259-2.036 4.422-1.396 1.106-3.2 1.687-5.527 1.687-2.677 0-4.888-.64-6.517-1.861-1.687-1.28-2.676-3.026-3.025-5.237h4.364c.116 1.164.64 2.153 1.57 2.851.931.757 2.095 1.106 3.608 1.106 1.047 0 1.92-.291 2.56-.873.64-.582.93-1.28.93-2.153 0-.756-.232-1.338-.698-1.803-.465-.466-1.047-.815-1.745-1.048-.698-.232-1.687-.523-2.91-.756-1.57-.35-2.85-.756-3.84-1.106-.988-.349-1.803-.989-2.5-1.803-.7-.815-1.048-1.92-1.048-3.375 0-1.803.698-3.316 2.036-4.48 1.397-1.163 3.258-1.687 5.702-1.687 2.385.116 4.422.756 5.993 2.036zM91.17 8.495c1.688.872 2.968 2.152 3.9 3.84.93 1.687 1.395 3.665 1.395 5.876 0 2.269-.465 4.247-1.396 5.934-.93 1.688-2.269 2.968-3.898 3.84-1.687.873-3.55 1.339-5.644 1.339-2.094 0-3.956-.466-5.643-1.339-1.688-.872-2.968-2.152-3.899-3.84-.93-1.687-1.454-3.665-1.454-5.934 0-2.27.465-4.19 1.454-5.876.931-1.688 2.27-2.968 3.899-3.84 1.687-.873 3.549-1.339 5.643-1.339 2.095 0 3.957.408 5.644 1.339zm-8.843 3.316c-.989.524-1.745 1.338-2.327 2.385-.582 1.106-.873 2.386-.873 3.957 0 1.57.291 2.909.873 4.014.582 1.048 1.396 1.862 2.327 2.386.99.523 2.037.756 3.2.756 1.164 0 2.211-.233 3.2-.756.99-.524 1.746-1.338 2.328-2.386.581-1.047.872-2.385.872-4.014 0-1.571-.29-2.91-.872-3.957-.582-1.105-1.397-1.861-2.328-2.385-.989-.524-2.036-.756-3.2-.756-1.163 0-2.21.232-3.2.756zM117.876 9.484c1.513 1.629 2.27 3.956 2.27 6.923v12.626h-4.48V16.93c0-1.92-.524-3.433-1.513-4.48-.99-1.047-2.328-1.571-4.073-1.571-1.804 0-3.2.582-4.305 1.687-1.048 1.164-1.63 2.793-1.63 5.004v11.52h-4.48V7.447h4.48v4.771c.582-1.629 1.571-2.85 2.91-3.782 1.338-.872 2.909-1.338 4.712-1.338 2.56-.058 4.597.757 6.11 2.386zM65.862 34.676c-1.571 1.339-2.327 3.317-2.327 5.935v.698h-2.968v3.84h2.968v17.804h4.538V45.207h5.003V41.31h-5.003v-.349c0-1.57.349-2.618 1.047-3.258.698-.64 2.153-.931 3.898-.873v-3.898c-3.083-.175-5.643.407-7.156 1.745zM91.23 42.415c-1.688-.873-3.55-1.339-5.645-1.339-2.094 0-3.956.466-5.643 1.339-1.687.872-2.967 2.152-3.898 3.84-.931 1.687-1.455 3.665-1.455 5.876 0 2.269.466 4.247 1.455 5.934.93 1.688 2.269 2.968 3.898 3.84 1.687.873 3.549 1.339 5.643 1.339 2.095 0 3.957-.466 5.644-1.339 1.687-.872 2.967-2.152 3.898-3.84.931-1.687 1.397-3.665 1.397-5.934 0-2.27-.466-4.19-1.397-5.876-.93-1.688-2.269-2.968-3.898-3.84zm-.175 13.73c-.582 1.048-1.397 1.862-2.328 2.386-.989.524-2.036.756-3.2.756-1.163 0-2.21-.232-3.2-.756-.989-.524-1.745-1.338-2.327-2.386-.582-1.047-.873-2.385-.873-4.014 0-1.571.291-2.91.873-3.956.582-1.106 1.338-1.862 2.327-2.386.99-.524 2.037-.756 3.2-.756 1.164 0 2.211.29 3.2.756.99.524 1.746 1.338 2.328 2.386.581 1.105.872 2.385.872 3.956 0 1.57-.29 2.909-.872 4.014zM120.785 58.356c-.465-.465-.698-1.338-.698-2.56V45.15h5.237v-3.84h-5.237v-5.353h-4.538v5.353h-3.49c-1.979 0-3.375.058-4.714.873-1.338.814-2.385 1.92-3.141 3.374V41.31h-4.48v21.644h4.48V52.015c0-2.211.698-3.608 1.803-4.713 1.28-1.28 2.677-2.095 4.713-2.153H115.549v10.59c0 2.617.582 4.421 1.804 5.526 1.163 1.106 2.909 1.688 5.236 1.688h2.735v-3.898h-2.153c-1.106 0-1.92-.233-2.386-.699zM157.207 43.404c-1.512-1.63-3.549-2.444-6.05-2.444-1.804 0-3.375.465-4.713 1.338-1.339.873-2.328 2.153-2.91 3.782v-4.77h-4.48v21.643h4.48V51.49c0-2.211.524-3.84 1.63-5.004 1.047-1.163 2.501-1.687 4.305-1.687 1.746 0 3.084.524 4.073 1.57.989 1.048 1.513 2.56 1.513 4.48v12.103h4.48V50.385c-.059-3.025-.815-5.352-2.328-6.981zM129.978 35.956H134.458V40.43600000000001H129.978zM134.458 44.16L134.458 62.953 129.978 62.953 129.978 41.309z"
                        />
                    </g>
                </svg>
            </router-link>
            <a href="/" class="back-home outline-cta">Découvrez le site<span class="outline-cta__arrow"><svg height="11" viewBox="0 0 12 11" width="12" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="#353d35" transform="translate(1 1)"><path d="m0 0h10v10"></path><path d="m10 0-10 10"></path></g></svg></span></a>
        </div>
     <section class="brand-video">
         
        <iframe src="https://player.vimeo.com/video/515489323"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
     </section>
    </main>
</template>

<script>
import BaseView from './BaseView';

export default {
    name: 'Identity',

    data() {
        return {

        };
    },

    extends: BaseView,
};
</script>

<style lang="scss" scoped>

.identity-menu {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 50px auto 0;
    padding: 0 20px;
    @media(min-width: 400px){
        padding: 0 50px;
    }   
    

     @media(min-width: 768px){
        padding: 0 90px;
    }   

    @media(min-width: 1440px) {
        max-width: 1240px;
        padding: 0 50px;
    }
}

.brand-video {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    margin-top: -120px;
}

iframe {
    position: absolute;
    top: 10rem;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    padding: 50px 20px 0;

    @media(min-width: 769px) {
        padding: 50px;
    }
    
    @media(min-width: 1440px) {
        top: 160px;
        padding: 0 150px;
        max-height: 650px;
    }
}

.back-home {
    font-size: 1.8rem;
    
    @media (max-width: 420px) {
        margin-right: 0;
        svg {
            display: none;
        }
    }
}

.identity-logo {
    @media (max-width:767px) {
        width: 120px;
    }
}

</style>